import { useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';

function MediaAdd({ onCreate, submitting }) {
  const [files, setFiles] = useState([]);
  const [localError, setLocalError] = useState('');

  const onDrop = useMemo(
    () => (acceptedFiles) => {
      if (!acceptedFiles?.length) return;
      const capped = acceptedFiles.slice(0, 10);
      setFiles(capped);
      setLocalError(acceptedFiles.length > 10 ? 'A maximum of 10 files is allowed per upload.' : '');
    },
    []
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    maxFiles: 10
  });

  async function handleSubmit(event) {
    event.preventDefault();
    if (!files.length) return;
    if (files.length > 10) {
      setLocalError('A maximum of 10 files is allowed per upload.');
      return;
    }

    const payload = files.length === 1 ? { file: files[0] } : { files };
    await onCreate(payload);
    setFiles([]);
    setLocalError('');
  }

  return (
    <form className="form-grid" onSubmit={handleSubmit}>
      <p className="field-label">
        Upload one or more files (maximum 10). The backend automatically fills type, mime, size, URL, storage
        provider, and status.
      </p>
      <div
        {...getRootProps()}
        className={`dropzone ${isDragActive ? 'dropzone-active' : ''} ${files.length ? 'dropzone-has-file' : ''}`}
      >
        <input {...getInputProps()} />
        <p>{isDragActive ? 'Drop files here...' : 'Drag files here or click to upload.'}</p>
        {files.length ? <small>{files.length} selected file(s)</small> : null}
      </div>
      {files.length ? (
        <div className="panel" style={{ margin: 0 }}>
          {files.map((selectedFile) => (
            <small key={`${selectedFile.name}-${selectedFile.size}`} style={{ display: 'block' }}>
              {selectedFile.name}
            </small>
          ))}
        </div>
      ) : null}
      {localError ? <p className="message-error">{localError}</p> : null}

      <button className="button-primary" type="submit" disabled={submitting || !files.length}>
        {submitting ? 'Saving...' : 'Create media'}
      </button>
    </form>
  );
}

export default MediaAdd;
